import { css } from 'emotion'

export const DropdownButtonStyles = css`
  display: inline-block;
`
